import { Plus, Trash2 } from "lucide-react";
import { input, lbl, PLATFORMS } from "./ambassadorApi";

/** Where the ambassador promotes: platform + handle / profile link (+ optional audience size). */
export const ChannelsEditor = ({ channels, onChange }) => {
  const set = (i, patch) => onChange(channels.map((c, idx) => (idx === i ? { ...c, ...patch } : c)));
  return (
    <div data-testid="channels-editor" className="space-y-3">
      {channels.map((c, i) => (
        <div key={i} data-testid={`channel-row-${i}`} className="grid grid-cols-12 gap-2 items-end">
          <div className="col-span-12 sm:col-span-3">
            <span className={lbl}>Platform</span>
            <select data-testid={`channel-platform-${i}`} value={c.platform} onChange={(e) => set(i, { platform: e.target.value })} className={input}>
              {PLATFORMS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
          </div>
          <div className="col-span-12 sm:col-span-5">
            <span className={lbl}>Handle or profile link</span>
            <input data-testid={`channel-handle-${i}`} value={c.handle} onChange={(e) => set(i, { handle: e.target.value })} placeholder="@yourhandle or https://…" className={input} required />
          </div>
          <div className="col-span-9 sm:col-span-3">
            <span className={lbl}>Audience (optional)</span>
            <input data-testid={`channel-followers-${i}`} value={c.followers || ""} onChange={(e) => set(i, { followers: e.target.value })} placeholder="e.g. 12k" className={input} />
          </div>
          <button type="button" data-testid={`channel-remove-${i}`} onClick={() => onChange(channels.filter((_, idx) => idx !== i))} disabled={channels.length === 1}
            className="col-span-3 sm:col-span-1 h-12 flex items-center justify-center text-[#5f5e5a] hover:text-[#ff2a85] disabled:opacity-30"><Trash2 size={15} /></button>
        </div>
      ))}
      {channels.length < 8 && (
        <button type="button" data-testid="channel-add" onClick={() => onChange([...channels, { platform: "tiktok", handle: "", followers: "" }])}
          className="inline-flex items-center gap-2 font-mono-d text-[10px] uppercase tracking-[0.2em] text-[#0a0a0b] hover:text-[#ff2a85]"><Plus size={13} /> Add another place you promote</button>
      )}
    </div>
  );
};
